<template lang="pug">
.body-search-follow
  div.modal-header
    span.sf-modal-title {{title}}
    span.sf-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body
    form(action='#' autocomplete='off' method='')
      .row
        .col-md-12
          div.topsearch.form-group
            input.form-control.follow-search-term(type='text', placeholder='Tìm theo tên hiển thị', v-model='searchText' @keyup="onFollowChange")
            .addons-button-clear(@click="onFollowClear" v-bind:style="clear_search ? 'display:block;' : 'display:none;' ")
            button.follow-search-button(type='button', @click='submitSearch($event)')
              i.material-icons search
      .row
        .col-md-12.box-list-follow
          .box-item-follow(v-for="f in user_followed")
            img(:src='f.userFollow.avatar' v-if='f.userFollow.avatar')
            img(src='../../assets/images/faces/avt-default.png' v-else)
            p {{f.userFollow.fullname || 'default'}}
            itemAdding
          
      .row
        .col-md-12.box-list-follow-mobile
          .box-item-follow-mobile(v-for="f in user_followed")
            img(:src='f.userFollow.avatar' v-if='f.userFollow.avatar')
            img(src='../../assets/images/faces/avt-default.png' v-else)
            p {{f.userFollow.fullname}}
            itemAdding

</template>

<script>
import itemAdding from './itemAdding'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'

export default {
  components: {
    itemAdding
  },
  props: {
    title: String
  },
  data() {
    return {
      searchText: '',
      clear_search: 0,
      user_followed: []
    }
  },
  methods: {
    submitSearch(event) {
      // console.log('search dang theo doi', event)
      this.$apollo.query({
        query: gql(graphql.GET_FOLLOWED),
        variables: {
          uid: this.$store.getters.user,
          keyword: '%' + this.searchText + '%'
        }
      })
      .then((response) => {
        this.user_followed = response.data.followes_aggregate.nodes
      })
      .catch((response) =>
        console.error(response)
      )
    },
    onFollowChange(e) {
      if (this.searchText.trim().length) {
        this.clear_search = 1
        if (e.keyCode === 13) this.submitSearch()
      } else this.onFollowClear()
    },
    onFollowClear() {
      this.searchText = ''
      this.clear_search = 0
      this.$apollo.queries.user_followed.refetch()
    }
  },
  apollo: {
    user_followed: {
      query: gql(graphql.GET_FOLLOWED),
      variables() {
        return {
          uid: this.$store.getters.user
        }
      },
      update: data => {
        return data.followes_aggregate.nodes
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
  --color-search-button: #FFEF45;
  --color-add-button: #FBF4D2;
  --color-title-button: #9F6A28;
}
.v--modal-overlay .v--modal-box {
  overflow: visible;
}
.body-search-follow {
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  font-family: 'adobe-clean', sans-serif;

  .sf-modal-title {
    float: left;
    font-size: 17px;
  }
  .sf-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }

  .topsearch{
    width: 490px;
    position: relative;
    margin: 0;
    .follow-search-term {
      float: left;
      border-top-right-radius: 0; 
      border-bottom-right-radius: 0;
      padding-right: 40px !important;
      width: 100%;
      border-right: none;
      margin-bottom: 13px;
    }
    .addons-button-clear {
      display: none; 
      background: url("../../assets/images/faces/ic_clear_24px.png") no-repeat center; 
      position: absolute; 
      right:5px; 
      top:8px;
      width: 40px;  
      height: 34px;
      border-radius: 5px; 
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .follow-search-button {
      position: absolute;
      border: 1px solid var(--color-background-button);
      border-left: none;
      cursor: pointer;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      background: var(--color-search-button);
      text-align: center;
      // -webkit-transition-duration: 0.4s; /* Safari */
      // transition-duration: 1s;
      &:active {
        background: var(--color-background-button);
        content: "";
        opacity: 1;
        transition: all 0.1s;
      }

      i {
        padding: 10px 5px;
      }
    }
  }

  .box-list-follow {
    position: relative;
    z-index: 10;
    .box-item-follow {
      float: left;
      width: 126px;
      height: auto; 
      margin-right: 11px;
      margin-bottom: 11px;
      display:table-cell;
      // position: relative;
      border: 1px solid #EAEAEA;
      border-radius: 5px;
      text-align: center;
      vertical-align: middle;
      &:nth-child(4n) {margin-right: 0;}
      img {width: 50px; height: 50px; border-radius: 50%; margin: 10px 0;}
      p {margin: 5px 10px;}
      button {margin-bottom: 12px;}
    }
  }
  .box-list-follow-mobile {
    display: none;
  }
}

@media (max-width: 375px) {
  .body-search-follow {
    width: 350px !important;
    margin-left: 225px !important;
  }
}

@media (max-width: 414px) {
  .body-search-follow {
    width: 350px !important;
    margin-left: 204px;
    .topsearch{
      width: 270px;
    }
    .box-list-follow {
      display: none;
    }
    .box-list-follow-mobile {
      display: block;
      .box-item-follow-mobile {
        float: left;
        width: 153px;
        height: auto; 
        margin-right: 11px;
        margin-bottom: 11px;
        display:table-cell;
        position: relative;
        border: 1px solid #EAEAEA;
        border-radius: 5px;
        text-align: center;
        vertical-align: middle;
        &:nth-child(2n) {margin-right: 0;}
        img {width: 50px; height: 50px; border-radius: 50%; margin: 10px 0;}
        p {margin: 5px 10px;}
        button {margin-bottom: 12px;}
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// modalFollowed.vue?83a0ca6c